<h1 mat-dialog-title>{{ data.message ?? 'you\'re sure?' }}</h1>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">No</button>
      <button mat-button cdkFocusInitial (click)="onYesClick()">Yes</button>
    </div>